import * as React from 'react';

import InvoiceDetails from '../../payment/InvoiceDetails';
import PaymentHistoryList from '../../payment/PaymentHistoryList';
import Utils from '../../common/utils';

import * as moment from 'moment';

interface Props {
	className?: string;
	actions: any;
	history: any;
	match: any;
	payments: PaymentHistory[];
	searchterm: string;
	onSearch: (e: any) => void;
}

interface State {
	payments: PaymentHistory[];
	searchterm: string;
}

class CustomerBillsPage extends React.Component<Props, State> {
	handleSearchDebounced = Utils.debounce(() => { this.search(this.state.searchterm); }, 200);

	constructor(props: Props) {
		super(props);
		this.state = {
			payments: [],
			searchterm: ''
		};
	}

	componentDidMount() {
		const sortedPayments = this.props.payments.sort(this.sortPaymentHistory);
		this.setState({ payments: sortedPayments });
	}

	onSearch = (e: any) => {
		this.setState({ searchterm: e.target.value }, () => {
			this.handleSearchDebounced();
		});
	}
	search = (searchterm: string) => {
		const value = searchterm.toLowerCase();
		let payments = this.props.payments.filter(function (c: PaymentHistory) {
			let date = Utils.formatDateAsUTC(c.date) || '';
			let stripeInvoiceNumber = c.stripeInvoiceNumber || '';
			return date.toLowerCase().startsWith(value) || stripeInvoiceNumber.toLowerCase().startsWith(value);
		});

		this.setState({ payments });
	}
	sortPaymentHistory = (a: PaymentHistory, b: PaymentHistory) => {
		return  (moment(a.createdDate!).utc()).isAfter(moment(b.createdDate!).utc()) ? -1 : 1;
	}
	render() {
		if (this.props.match.params.pageId) {
			return (
				<InvoiceDetails baseUrl={`/admin/customers/${this.props.match.params.customerId}/bills`} {...this.props} />
			);
		}
		else {
			return (
				<PaymentHistoryList 
					baseUrl={`/admin/customers/${this.props.match.params.customerId}/bills`} 
					{...this.props} 
					payments={this.state.payments}
					searchterm={this.state.searchterm}
					onSearch={this.onSearch}
				/>
			);
		}
	}
}
export default CustomerBillsPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerBillsPage.tsx